module.exports = __webpack_public_path__ + "c3785b533dd98e77f68ecae936635aa5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-robin-hood-s.png
// module id = 2900
// module chunks = 0